<div *ngIf="barcode$ | async as barcode">
  <div class="d-flex flex-wrap flex-column justify-content-around align-items-center bg-primary barcode-container">
    <ng-container *ngIf="cardToken$ | async as cardToken">
      <img class="chase-logo" *ngIf="cardToken.CardIssuer == 'CHASE'" src="/assets/images/payment-icons/chase.png" />
    </ng-container>

    <div class="bg-white rounded qr-container">
      <div class="qr text-center">
        <qrcode
          [qrdata]="barcode?.Barcode"
          [width]="120"
          [errorCorrectionLevel]="'M'"
          [elementType]="'svg'"
          [allowEmptyString]="true"
        ></qrcode>

        <ng-container *ngIf="populationName == population.Kids; else defaultDescription">
          <div class="font-size-12">{{ 'kids.barcode.description' | translate }}</div>
        </ng-container>
        <ng-template #defaultDescription>
          <div class="font-size-12">{{ 'barcode.description' | translate }}</div>
        </ng-template>
      </div>

      <ng-container *notInPopulation="[population.Kids]">
        <button class="btn btn-primary d-flex align-items-center" [routerLink]="'/hawksbucks'" *ngIf="showTickets">
          <div class="icon material-icons me-1">confirmation_number</div>
          <div class="text-white fw-bold">{{ 'barcode.show.tickets' | translate }}</div>
        </button>
      </ng-container>
    </div>

    <!-- Not Owner Barcode Body -->
    <div class="w-100 barcode-content-container bg-primary text-white">
      <div class="barcode-content mb-4">
        <!--Balances-->
        <div class="widgets-spacing">
          <fgb-balance-widgets></fgb-balance-widgets>

          <ng-container *notInPopulation="[population.Kids]">
            <fgb-ecash-button></fgb-ecash-button>
          </ng-container>
        </div>

        <ng-container *notInPopulation="[population.Kids]">
          <ng-container *ngIf="card$ | async as memberCard">
            <ng-container *ngIf="memberCard.RetailDiscountLevel">
              <div class="discount-row mt-3">
                <div class="discount-label">
                  {{ 'barcode.retail.discount' | translate }}
                </div>
                <div class="discount-value">{{ memberCard.RetailDiscountLevel }}%</div>
              </div>
            </ng-container>

            <ng-container *ngIf="memberCard.RetailDiscountLevel">
              <div class="discount-row">
                <div class="discount-label">
                  {{ 'barcode.discount' | translate }}
                </div>
                <div class="discount-value">{{ memberCard.DiscountLevel }}%</div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
